import Content from './HighlightsList';
import HighlightsListHeader from './HighlightsListHeader';

const HighlightsList = () => <></>;

HighlightsList.Header = HighlightsListHeader;
HighlightsList.Content = Content;

export default HighlightsList;
